import React from 'react';
import ReactDOM from 'react-dom';
import CollectionSearchContainer from '../common/CollectionSearchContainer';

import SearchFiltersContainer from './SearchFiltersContainer';
import ResultsListContainer from '../common/ResultsListContainer';
import PaginationContainer from '../common/PaginationContainer';

import ResultItemContainer from './results/ResultItemContainer';
const rootElement = document.getElementById('master-courses-search-results');

const collectionUrl = document.body.getAttribute('data-base-url');
const vocabularyDomain = 'unife.masterschool.vocabularies';
const vocabularyNames = [
  'MasterTypesCatalog',
  'DisciplinaryAreasCatalog',
  'Venues',
  'LanguagesCatalog',
  'EducationalActivitiesCatalog',
  'Durations',
];

ReactDOM.createRoot(rootElement).render(
  <CollectionSearchContainer
    collectionUrl={collectionUrl}
    vocabularyDomain={vocabularyDomain}
    vocabularyNames={vocabularyNames}
    translationsDomain="unife.iussumstheme"
  >
    <SearchFiltersContainer />
    <ResultsListContainer resultItemContainer={ResultItemContainer} />
    <PaginationContainer />
  </CollectionSearchContainer>
);
